unit DonorDeclaration;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WebForm.Core, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, Grid.Plugins, WEBLib.Lists, WEBLib.ExtCtrls,
  SMX.XDataSvc.Utils, GA.Return.Types, XData.Dataset.Utils;

type
  TDonorDeclarationsForm = class(TCoreWebForm)
    DeclarationCloseButton: TButton;
    DeclarationCancelButton: TButton;
    SaveDeclarationButton: TButton;
    DeclarationDataSource: TDataSource;
    DeclarationDataSet: TXDataWebDataSet;
    DeclarationDataSetId: TIntegerField;
    DeclarationDataSetDateAdded: TDateTimeField;
    DeclarationDataSetAddedBy: TIntegerField;
    DeclarationDataSetLastUpdatedBy: TIntegerField;
    DeclarationDataSetLastUpdated: TDateTimeField;
    DeclarationDataSetDonorId: TIntegerField;
    DeclarationDataSetDateSigned: TDateTimeField;
    DeclarationDataSetDateStarted: TDateTimeField;
    DeclarationDataSetClaimCoverage: TStringField;
    DeclarationDataSetDeclarationMethod: TStringField;
    DeclarationDataSetDateRevoked: TDateTimeField;
    DeclarationDataSetRevocationMethod: TStringField;
    DeclarationDataSetDeclarationStatus: TStringField;
    DeclarationDataSetRevocationNote: TStringField;
    DeclarationDataSetDonationId: TIntegerField;
    DeclarationDataTable: TDBTableControl;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    Refresh: TTimer;
    DeclarationDateSigned: TDBDateTimePicker;
    RevocationNote: TDBEdit;
    DateRevoked: TDBDateTimePicker;
    NewDeclarationButton: TButton;
    DeclarationStatus: TDBLookupComboBox;
    ClaimCoverage: TDBLookupComboBox;
    DeclarationMethod: TDBLookupComboBox;
    RevocationMethod: TDBLookupComboBox;
    RevokeCheckDlg: TMessageDlg;
    RefreshDeclarations: TTimer;
    SingleDonations: TLookupComboBox;
    procedure DeclarationCloseButtonClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure DeclarationCancelButtonClick(Sender: TObject);
    procedure RefreshTimer(Sender: TObject);
    procedure DeclarationDataTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure NewDeclarationButtonClick(Sender: TObject);
    procedure SaveDeclarationButtonClick(Sender: TObject);
    procedure DeclarationDataSetAfterPost(DataSet: TDataSet);
    procedure DeclarationDataSetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure CompChange(Sender: TObject);
    procedure RefreshDeclarationsTimer(Sender: TObject);
    procedure ClaimCoverageChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
    FDonorId: integer;
    FGridPlugin: TGridPlugin;
    FFilterStr: string;
    FNotReceived: boolean;
    FDonationDate: TDate;
    FNewDeclaration: boolean;
    FDonations: TArray<TSingleDeclarationData>;
    FSetStatusOk: boolean;
    FDonationAmount: string;
    FFromManualEntry: boolean;
    FDeclarationId: integer;
    procedure SetDonorId(ADonorId: integer);
    procedure RefreshControls;
    procedure CreateGridPlugin;
    procedure RefreshData;
    procedure SaveDeclaration;
    procedure SetComponents(AEnabled: boolean; AType: string);
    procedure LoadComboBoxes;
    procedure UpdateDeclarations;
    [async]
    procedure CallUpdateDeclarations(ADeclarationId: integer; ADonorId: integer; AStatus: string; ACoverage: string; ADateSigned: TDate); async;
    procedure CheckForNotReceivedDeclaration;
    function FindSingleDeclarationText(AId: integer): string;
    procedure UpdateSingleCoverageList;
    //procedure SetDonationDate(ADonationDate: TDate);
    procedure AddDoanationDateToSingleDonations;
  protected
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    procedure EditSelectedDeclaration(ARecordId: integer);
    [async]
    procedure RevokeSelectedDeclaration(ARecordId: integer); async;
    procedure InitialiseComponents;
    procedure OkToSave;

    [async]
    procedure CheckForAvailableSingleDonations; async;
    function GetDonationDateFromDisplay: TDate;
  public
    { Public declarations }
    procedure LoadData;

    property DonorId: integer read FDonorId write SetDonorId;
    property DonationDate: TDate read FDonationDate write FDonationDate; //SetDonationDate;
    property NewDeclaration: boolean read FNewDeclaration;
    property SetStatusOk: boolean read FSetStatusOk;
    property DonationAmount: string read FDonationAmount write FDonationAmount;
    property FromManualEntry: boolean read FFromManualEntry write FFromManualEntry;//SetFromManualEntry;
    property DeclarationId: integer read FDeclarationId write FDeclarationId;
  protected procedure LoadDFMValues; override; end;

var
  DonorDeclarationsForm: TDonorDeclarationsForm;

implementation

{$R *.dfm}

uses
  MainDataModule, smx.webcore.types, WEBLib.WebCtrls, SMX.Web.Layout.Utils,
  XData.Web.Client;


procedure TDonorDeclarationsForm.InitialiseComponents;
begin
  DateRevoked.Date := 0;
  DeclarationDateSigned.Date := 0;
  DateRevoked.Text := 'dd/mm/yyyy';
  DeclarationDateSigned.Text := 'dd/mm/yyyy';
  RevocationNote.Text := '';
  DeclarationStatus.ItemIndex := -1;
  RevocationMethod.ItemIndex := -1;
  ClaimCoverage.ItemIndex := -1;
  DeclarationMethod.ItemIndex := -1;
  DeclarationStatus.ItemIndex := -1;
end;

procedure TDonorDeclarationsForm.DeclarationCancelButtonClick(Sender: TObject);
var
  lFilterStr: string;
begin
  DeclarationDataset.Cancel;
  SetComponents(False,'');
end;

procedure TDonorDeclarationsForm.DeclarationCloseButtonClick(Sender: TObject);
begin
  ModalResult := mrClose;
end;

procedure TDonorDeclarationsForm.DeclarationDataSetAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
begin
  TXDataDSUtils.UpdateAllIds(TXDataWebDataSet(Sender), Info, 'Id', true);
  FDeclarationId := Sender.FieldByName('Id').AsInteger;

  RefreshData;
  RefreshDeclarations.Enabled := True;
end;

procedure TDonorDeclarationsForm.DeclarationDataSetAfterPost(DataSet: TDataSet);
begin
  DeclarationDataset.ApplyUpdates;
  SetComponents(False, '');
end;

procedure TDonorDeclarationsForm.DeclarationDataTableGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: string;
  lId: integer;
  lSingleDecText: string;
  lData: string;
begin
  if ARow = 0 then
    Exit;

  if DeclarationDataTable.Columns[ACol].Title = 'Date Revoked' then
  begin
    if DeclarationDataset.FieldByName('DateRevoked').IsNull then
      DeclarationDataTable.Cells[ACol, ARow] := '';
  end;

  if DeclarationDataTable.Columns[ACol].Title = 'Date Signed' then
  begin
    if (DeclarationDataset.FieldByName('DateSigned').IsNull) or
       (DeclarationDataset.FieldByName('DateSigned').AsDateTime < 29219) then
      DeclarationDataTable.Cells[ACol, ARow] := '';
  end;

  if DeclarationDataTable.Columns[ACol].Title = 'Start Date' then
  begin
    if (DeclarationDataset.FieldByName('DateStarted').IsNull) or
       (DeclarationDataset.FieldByName('DateSigned').AsDateTime < 29219) then
      DeclarationDataTable.Cells[ACol, ARow] := '';
  end;

  if DeclarationDataTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := DeclarationDataset.FieldByName('Id').AsString;
    AddRowActions(RecordId, AElement.Element);
  end;

  if DeclarationDataTable.Columns[ACol].Title = 'Claim Coverage' then
  begin
    if DeclarationDataset.FieldByName('ClaimCoverage').AsString = 'Single' then
    begin
      lId := DeclarationDataset.FieldByName('Id').AsInteger;
      lSingleDecText := FindSingleDeclarationText(lId);
      DeclarationDataTable.Cells[ACol, ARow] := lSingleDecText;
    end;
  end;
end;

procedure TDonorDeclarationsForm.CompChange(Sender: TObject);
begin
  CheckForNotReceivedDeclaration;
  OkToSave;
end;

procedure TDonorDeclarationsForm.LoadComboBoxes;
begin
  DeclarationStatus.LookupValues.AddPair('NotReceived', 'Not Received');
  DeclarationStatus.LookupValues.AddPair('Active', 'Active');
  DeclarationStatus.LookupValues.AddPair('Revoked', 'Revoked');
  DeclarationStatus.LookupValues.AddPair('Used', 'Used');

  ClaimCoverage.LookupValues.AddPair('All', 'All');
  ClaimCoverage.LookupValues.AddPair('Future', 'Future');
  ClaimCoverage.LookupValues.AddPair('Single', 'Single');

  DeclarationMethod.LookupValues.AddPair('Written', 'Written');
  DeclarationMethod.LookupValues.AddPair('Audio', 'Audio');
  DeclarationMethod.LookupValues.AddPair('Email', 'Email');
  DeclarationMethod.LookupValues.AddPair('Web', 'Web');
  DeclarationMethod.LookupValues.AddPair('SMS', 'SMS');
  DeclarationMethod.LookupValues.AddPair('DeedOfCovenant', 'Deed Of Covenant');
  DeclarationMethod.LookupValues.AddPair('Unknown', 'Unknown');

  RevocationMethod.LookupValues.AddPair('Written', 'Written');
  RevocationMethod.LookupValues.AddPair('Audio', 'Audio');
  RevocationMethod.LookupValues.AddPair('Email', 'Email');
  RevocationMethod.LookupValues.AddPair('Web', 'Web');
  RevocationMethod.LookupValues.AddPair('SMS', 'SMS');
  RevocationMethod.LookupValues.AddPair('DeedOfCovenant', 'Deed Of Covenant');
  RevocationMethod.LookupValues.AddPair('Unknown', 'Unknown');

end;

procedure TDonorDeclarationsForm.LoadData;
var
  lFilterStr: string;
begin
  CreateGridPlugin;
end;

procedure TDonorDeclarationsForm.NewDeclarationButtonClick(Sender: TObject);
begin
  SetComponents(true, 'New');
  DeclarationDataset.Insert;
end;

procedure TDonorDeclarationsForm.SetDonorId(ADonorId: integer);
var
  lFilterStr: string;
begin
  FDonorId := ADonorId;
  FFilterStr := Format('DonorId eq %d', [FDonorId]);
  //KSS  RefreshControls;
  Refresh.Enabled := true;

  if FFromManualEntry = False then
    CheckForAvailableSingleDonations
  else
    AddDoanationDateToSingleDonations;
end;

procedure TDonorDeclarationsForm.SaveDeclarationButtonClick(Sender: TObject);
begin
  inherited;
  SaveDeclaration;
end;

procedure TDonorDeclarationsForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  FFromManualEntry := False;
end;

procedure TDonorDeclarationsForm.WebFormShow(Sender: TObject);
begin
  LoadComboBoxes;
  InitialiseComponents;
  LoadData;
  SetComponents(False, '');
  FNotReceived := False;
  FNewDeclaration := False;
end;

procedure TDonorDeclarationsForm.RefreshTimer(Sender: TObject);
begin
  Refresh.Enabled := false;
  RefreshControls;
end;

procedure TDonorDeclarationsForm.RefreshControls;
var
  lFilterStr: string;
begin
  lFilterStr := Format('DonorId eq %d', [FDonorId]);
  FGridPlugin.SetPreparedFilter(lFilterStr);
end;

procedure TDonorDeclarationsForm.CreateGridPlugin;
begin
  FGridPlugin := TGridPlugin.Create(DeclarationDataTable, DeclarationDataset, lcPaginator, lbPaginationInfo,
    TSortPair.Create(0, sdDesc));
  FGridPlugin.SetPageSize(10);
  FGridPlugin.SetFilterText('');
end;

procedure TDonorDeclarationsForm.RefreshData;
begin
  FGridPlugin.SetPreparedFilter(FFilterStr);
end;

procedure TDonorDeclarationsForm.SetComponents(AEnabled: boolean; AType: string);
begin
  if AType = 'Revoke' then
  begin
    DeclarationStatus.Enabled := not AEnabled;
    ClaimCoverage.Enabled := not AEnabled;
    DeclarationMethod.Enabled := not AEnabled;
    RevocationMethod.Enabled := AEnabled;
    DateRevoked.Enabled := AEnabled;
    DateRevoked.Date := Now;
    RevocationNote.Enabled := AEnabled;
    SingleDonations.Enabled := False;
  end
  else
  begin
    DeclarationDateSigned.Enabled := AEnabled;
    DeclarationStatus.Enabled := AEnabled;
    ClaimCoverage.Enabled := AEnabled;
    DeclarationMethod.Enabled := AEnabled;
    SingleDonations.Enabled := False;

    if AType = 'New' then
    begin
      RevocationMethod.Enabled := not AEnabled;
      DateRevoked.Enabled := not AEnabled;
      RevocationNote.Enabled := not AEnabled;


      if SingleDonations.ItemIndex <> -1 then
      begin
        SingleDonations.LookupValues.Delete(SingleDonations.ItemIndex);
        SingleDonations.ItemIndex := -1;
      end;
    end
    else
    begin
      RevocationMethod.Enabled := AEnabled;
      DateRevoked.Enabled := AEnabled;
      RevocationNote.Enabled := AEnabled;
    end;
  end;
end;

procedure TDonorDeclarationsForm.SaveDeclaration;
var
  lDonationIdStr: string;
  lDonationId: integer;
begin
  DeclarationDataset.FieldByName('DonorId').AsInteger := FDonorId;

  try
  if DeclarationDataset.FieldByName('ClaimCoverage').AsString = 'Single' then
  begin
    if SingleDonations.Value <> '' then
    begin
      lDonationIdStr := SingleDonations.Value;
      lDonationId := StrToInt(lDonationIdStr);
      FDonationDate := GetDonationDateFromDisplay;

      DeclarationDataset.FieldByName('DonationId').AsInteger := lDonationId;

      UpdateSingleCoverageList;
    end;
  end;
  except
    DeclarationDataset.FieldByName('DonationId').AsInteger := 0;
  end;

  DeclarationDataset.Post;
  SaveDeclarationButton.Enabled := False;
  FNewDeclaration := True;
end;

procedure TDonorDeclarationsForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure EditClick(Sender: TObject);
  begin
    EditSelectedDeclaration(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure RevokeClick(Sender: TObject);
  begin
    RevokeSelectedDeclaration(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

var
  Span: THTMLSpan;
begin

  if DeclarationDataSet.FieldByName('DeclarationStatus').AsString <> 'Revoked' then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'Edit');
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @EditClick;
  end;
  if DeclarationDataSet.FieldByName('DeclarationStatus').AsString = 'Active' then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-hand', 'Revoke');
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @RevokeClick;
  end;
end;

procedure TDonorDeclarationsForm.EditSelectedDeclaration(ARecordId: integer);
begin
  if not DeclarationDataSet.Locate('Id', ARecordId, []) then
  begin
    ShowMessage('The selected record could not be found. Please refresh the list and try again.');
    Exit;
  end;
  SetComponents(True, 'Edit');
  DeclarationDataSet.Edit;
  SaveDeclarationButton.Enabled := true;
end;


procedure TDonorDeclarationsForm.RevokeSelectedDeclaration(ARecordId: integer); {$IFDEF PAS2JS}async;{$ENDIF}
var
  lMR: TModalResult;

begin
  if DeclarationDataSet.Locate('Id', ARecordId, []) then
  begin
    lMR := await(TModalResult, RevokeCheckDlg.ShowDialog('Are you sure you want to revoke this declaration?',
      WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));

    if lMR = mrYes then
    begin
      DeclarationDataSet.Edit;
      DeclarationDataSet.FieldByName('DeclarationStatus').AsString := 'Revoked';
      DeclarationDataSet.FieldByName('DateRevoked').AsDateTime := Date;
      SetComponents(True, 'Revoke');
      SaveDeclarationButton.Enabled := true;
    end;
  end;
end;

procedure TDonorDeclarationsForm.OkToSave;
var
  lOk: boolean;
begin
  if RevocationMethod.Enabled and DateRevoked.Enabled and RevocationNote.Enabled then
    lOk := (RevocationMethod.Value <> '') and (DateRevoked.Date <> 0)
  else
    lOk := True;

  lOk := lOk and ((DeclarationDateSigned.Date <> 0) and
         (DeclarationStatus.Value <> '') and
         (ClaimCoverage.Value <>  '') and
         (DeclarationMethod.Value <> '' ) or FNotReceived);

  SaveDeclarationButton.Enabled := lOk;
end;

procedure TDonorDeclarationsForm.RefreshDeclarationsTimer(Sender: TObject);
begin
  RefreshDeclarations.Enabled := False;
  UpdateDeclarations;
//KSS  FDeclarationId := DeclarationDataset.FieldByName('Id').AsInteger;
end;

procedure TDonorDeclarationsForm.UpdateDeclarations;
var
//KSS  lId: integer;
  lDonorId: integer;
  lStatus: string;
  lCoverage: string;
  lDateSigned: TDate;
begin

  if DeclarationDataset.Locate('Id', FDeclarationId, []) then
  begin
    //KSS lId := DeclarationDataset.FieldByName('Id').AsInteger;
    lDonorId := DeclarationDataset.FieldByName('DonorId').AsInteger;
    lStatus := DeclarationDataset.FieldByName('DeclarationStatus').AsString;
    lCoverage := DeclarationDataset.FieldByName('ClaimCoverage').AsString;
    lDateSigned := DeclarationDataset.FieldByName('DateSigned').AsDateTime;
  end;

  if lStatus = 'Active' then
    CallUpdateDeclarations(FDeclarationId, lDonorId, lStatus, lCoverage, lDateSigned);
  Refresh.Enabled := true;
end;

procedure TDonorDeclarationsForm.CallUpdateDeclarations(ADeclarationId: integer; ADonorId: integer; AStatus: string; ACoverage: string; ADateSigned: TDate); {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  JSONData: boolean;//string;
  lChangeDonorStatusToOk: boolean;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.UpdateDeclarations',
      [ADeclarationId, ADonorId, AStatus, ACoverage, ADateSigned, FDonationDate]));
  lResult := lRetval.ResultAsObject;
  lChangeDonorStatusToOk := JS.ToBoolean(lResult['value']);

  FSetStatusOk := lChangeDonorStatusToOk;

  RefreshData;
end;

procedure TDonorDeclarationsForm.CheckForNotReceivedDeclaration;
begin
  if DeclarationStatus.ItemIndex = 0 then
  begin
    FNotReceived := true;
  end
  else
  begin
    FNotReceived := False;
  end;
end;

procedure TDonorDeclarationsForm.ClaimCoverageChange(Sender: TObject);
begin
  if DeclarationDataSet.FieldByName('ClaimCoverage').AsString = 'Single' then
  begin
    SingleDonations.Enabled := True;
  end
  else
  begin
    SingleDonations.Clear;
    SingleDonations.Enabled := False;
  end;
end;

procedure TDonorDeclarationsForm.CheckForAvailableSingleDonations; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  JSONData: string;
  lDonation: TSingleDeclarationData;
  lIdx: integer;

  lList: JS.TJSArray;
  lSingleDonation: JS.TJSObject;
  lValue: string;
  lDisplay: string;

begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.SingleDonationAllocation',
      [FDonorId]));
  lResult := lRetval.ResultAsObject;
  lList := JS.toArray(lResult['value']);

  FDonations := TArray<TSingleDeclarationData>(lList);

  for lIdx := 0 to Length(FDonations)-1 do
  begin
    lDonation := FDonations[lIdx];

    if lDonation.Used = False then
    begin
      lDisplay := lDonation.Display;
      lValue := lDonation.Value;
      SingleDonations.LookupValues.AddPair(lValue, lDisplay);
    end;
  end;
end;

function TDonorDeclarationsForm.FindSingleDeclarationText(AId: integer): string;
var
  lIdx: integer;
  lDonation: TSingleDeclarationData;
  lDecId: integer;
  lResult: string;
begin
  for lIdx := 0 to Length(FDonations)-1 do
  begin
    lDonation := FDonations[lIdx];

    if AId = lDonation.DeclarationId then
    begin
      lResult := 'Single:' + lDonation.Display;
      break
    end;
  end;

  if lResult = '' then
    lResult := 'Single:' + SingleDonations.DisplayText;

  result := lResult;
end;

procedure TDonorDeclarationsForm.UpdateSingleCoverageList;
begin
  SingleDonations.LookupValues.Clear;

  if FDonationDate <> 0 then
    CheckForAvailableSingleDonations;
end;

procedure TDonorDeclarationsForm.AddDoanationDateToSingleDonations;
var
  lDonationIdentifier: string;
begin
  lDonationIdentifier := FormatDateTime('dd/mm/yyyy', FDonationDate) + ': ' + Format('£%.s', [FDonationAmount]);

  SingleDonations.LookupValues.AddPair('-1', lDonationIdentifier);
end;

function TDonorDeclarationsForm.GetDonationDateFromDisplay: TDate;
var
  lDisplay: string;
  lDelimeter: integer;
  lDateStr: string;
begin
  try
    lDisplay := SingleDonations.DisplayText;
    lDelimeter := Pos(':', lDisplay);

    lDateStr := Copy(lDisplay, 1, lDelimeter-1);
    result := StrToDate(lDateStr);
  except
    result := 0;
  end;
end;


procedure TDonorDeclarationsForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('DeclarationPageInfo');
  DeclarationCloseButton := TButton.Create('DeclarationCloseButton');
  DeclarationCancelButton := TButton.Create('DeclarationCancelButton');
  SaveDeclarationButton := TButton.Create('SaveDeclarationButton');
  DeclarationDataTable := TDBTableControl.Create('DeclarationsGrid');
  lcPaginator := TListControl.Create('DeclarationPagination');
  DeclarationDateSigned := TDBDateTimePicker.Create('DeclarationDateSigned');
  RevocationNote := TDBEdit.Create('RevocationNote');
  DateRevoked := TDBDateTimePicker.Create('DateRevoked');
  NewDeclarationButton := TButton.Create('NewDeclarationButton');
  DeclarationStatus := TDBLookupComboBox.Create('DeclarationStatus');
  ClaimCoverage := TDBLookupComboBox.Create('ClaimCoverage');
  DeclarationMethod := TDBLookupComboBox.Create('DeclarationMethod');
  RevocationMethod := TDBLookupComboBox.Create('RevocationMethod');
  RevokeCheckDlg := TMessageDlg.Create(Self);
  SingleDonations := TLookupComboBox.Create('SingleDonations');
  DeclarationDataSource := TDataSource.Create(Self);
  DeclarationDataSet := TXDataWebDataSet.Create(Self);
  DeclarationDataSetId := TIntegerField.Create(Self);
  DeclarationDataSetDateAdded := TDateTimeField.Create(Self);
  DeclarationDataSetAddedBy := TIntegerField.Create(Self);
  DeclarationDataSetLastUpdatedBy := TIntegerField.Create(Self);
  DeclarationDataSetLastUpdated := TDateTimeField.Create(Self);
  DeclarationDataSetDonorId := TIntegerField.Create(Self);
  DeclarationDataSetDateSigned := TDateTimeField.Create(Self);
  DeclarationDataSetDateStarted := TDateTimeField.Create(Self);
  DeclarationDataSetClaimCoverage := TStringField.Create(Self);
  DeclarationDataSetDeclarationMethod := TStringField.Create(Self);
  DeclarationDataSetDateRevoked := TDateTimeField.Create(Self);
  DeclarationDataSetRevocationMethod := TStringField.Create(Self);
  DeclarationDataSetDeclarationStatus := TStringField.Create(Self);
  DeclarationDataSetRevocationNote := TStringField.Create(Self);
  DeclarationDataSetDonationId := TIntegerField.Create(Self);
  Refresh := TTimer.Create(Self);
  RefreshDeclarations := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  DeclarationCloseButton.BeforeLoadDFMValues;
  DeclarationCancelButton.BeforeLoadDFMValues;
  SaveDeclarationButton.BeforeLoadDFMValues;
  DeclarationDataTable.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DeclarationDateSigned.BeforeLoadDFMValues;
  RevocationNote.BeforeLoadDFMValues;
  DateRevoked.BeforeLoadDFMValues;
  NewDeclarationButton.BeforeLoadDFMValues;
  DeclarationStatus.BeforeLoadDFMValues;
  ClaimCoverage.BeforeLoadDFMValues;
  DeclarationMethod.BeforeLoadDFMValues;
  RevocationMethod.BeforeLoadDFMValues;
  RevokeCheckDlg.BeforeLoadDFMValues;
  SingleDonations.BeforeLoadDFMValues;
  DeclarationDataSource.BeforeLoadDFMValues;
  DeclarationDataSet.BeforeLoadDFMValues;
  DeclarationDataSetId.BeforeLoadDFMValues;
  DeclarationDataSetDateAdded.BeforeLoadDFMValues;
  DeclarationDataSetAddedBy.BeforeLoadDFMValues;
  DeclarationDataSetLastUpdatedBy.BeforeLoadDFMValues;
  DeclarationDataSetLastUpdated.BeforeLoadDFMValues;
  DeclarationDataSetDonorId.BeforeLoadDFMValues;
  DeclarationDataSetDateSigned.BeforeLoadDFMValues;
  DeclarationDataSetDateStarted.BeforeLoadDFMValues;
  DeclarationDataSetClaimCoverage.BeforeLoadDFMValues;
  DeclarationDataSetDeclarationMethod.BeforeLoadDFMValues;
  DeclarationDataSetDateRevoked.BeforeLoadDFMValues;
  DeclarationDataSetRevocationMethod.BeforeLoadDFMValues;
  DeclarationDataSetDeclarationStatus.BeforeLoadDFMValues;
  DeclarationDataSetRevocationNote.BeforeLoadDFMValues;
  DeclarationDataSetDonationId.BeforeLoadDFMValues;
  Refresh.BeforeLoadDFMValues;
  RefreshDeclarations.BeforeLoadDFMValues;
  try
    Width := 812;
    Height := 698;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 594;
    lbPaginationInfo.Top := 160;
    lbPaginationInfo.Width := 171;
    lbPaginationInfo.Height := 25;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    DeclarationCloseButton.SetParentComponent(Self);
    DeclarationCloseButton.Name := 'DeclarationCloseButton';
    DeclarationCloseButton.Left := 288;
    DeclarationCloseButton.Top := 336;
    DeclarationCloseButton.Width := 96;
    DeclarationCloseButton.Height := 25;
    DeclarationCloseButton.Caption := 'Close';
    DeclarationCloseButton.ChildOrder := 1;
    DeclarationCloseButton.ElementClassName := 'btn';
    DeclarationCloseButton.ElementPosition := epIgnore;
    DeclarationCloseButton.HeightStyle := ssAuto;
    DeclarationCloseButton.HeightPercent := 100.000000000000000000;
    DeclarationCloseButton.WidthStyle := ssAuto;
    DeclarationCloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationCloseButton, Self, 'OnClick', 'DeclarationCloseButtonClick');
    DeclarationCancelButton.SetParentComponent(Self);
    DeclarationCancelButton.Name := 'DeclarationCancelButton';
    DeclarationCancelButton.Left := 390;
    DeclarationCancelButton.Top := 336;
    DeclarationCancelButton.Width := 96;
    DeclarationCancelButton.Height := 25;
    DeclarationCancelButton.Caption := 'Cancel';
    DeclarationCancelButton.ChildOrder := 1;
    DeclarationCancelButton.ElementClassName := 'btn';
    DeclarationCancelButton.ElementPosition := epIgnore;
    DeclarationCancelButton.Enabled := False;
    DeclarationCancelButton.HeightStyle := ssAuto;
    DeclarationCancelButton.HeightPercent := 100.000000000000000000;
    DeclarationCancelButton.Visible := False;
    DeclarationCancelButton.WidthStyle := ssAuto;
    DeclarationCancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationCancelButton, Self, 'OnClick', 'DeclarationCancelButtonClick');
    SaveDeclarationButton.SetParentComponent(Self);
    SaveDeclarationButton.Name := 'SaveDeclarationButton';
    SaveDeclarationButton.Left := 492;
    SaveDeclarationButton.Top := 336;
    SaveDeclarationButton.Width := 96;
    SaveDeclarationButton.Height := 25;
    SaveDeclarationButton.Caption := 'Save';
    SaveDeclarationButton.ChildOrder := 1;
    SaveDeclarationButton.ElementClassName := 'btn';
    SaveDeclarationButton.ElementPosition := epIgnore;
    SaveDeclarationButton.Enabled := False;
    SaveDeclarationButton.HeightStyle := ssAuto;
    SaveDeclarationButton.HeightPercent := 100.000000000000000000;
    SaveDeclarationButton.WidthStyle := ssAuto;
    SaveDeclarationButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveDeclarationButton, Self, 'OnClick', 'SaveDeclarationButtonClick');
    DeclarationDataTable.SetParentComponent(Self);
    DeclarationDataTable.Name := 'DeclarationDataTable';
    DeclarationDataTable.Left := 19;
    DeclarationDataTable.Top := 32;
    DeclarationDataTable.Width := 569;
    DeclarationDataTable.Height := 281;
    DeclarationDataTable.ElementClassName := 'table table-striped table-bordered  table-hover';
    DeclarationDataTable.HeightStyle := ssAuto;
    DeclarationDataTable.WidthStyle := ssAuto;
    DeclarationDataTable.BorderColor := clSilver;
    DeclarationDataTable.ChildOrder := 1;
    DeclarationDataTable.ElementPosition := epIgnore;
    DeclarationDataTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    SetEvent(DeclarationDataTable, Self, 'OnGetCellChildren', 'DeclarationDataTableGetCellChildren');
    DeclarationDataTable.Columns.Clear;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'DateSigned';
      Title := 'Date Signed';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'DateStarted';
      Title := 'Start Date';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'DeclarationStatus';
      Title := 'Declaration Status';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'ClaimCoverage';
      Title := 'Claim Coverage';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'DeclarationMethod';
      Title := 'Declaration Method';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'DateRevoked';
      Title := 'Date Revoked';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'RevocationMethod';
      Title := 'Revocation Method';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      DataField := 'RevocationNote';
      Title := 'Revocation Note';
    end;
    with DeclarationDataTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    DeclarationDataTable.DataSource := DeclarationDataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 594;
    lcPaginator.Top := 117;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    DeclarationDateSigned.SetParentComponent(Self);
    DeclarationDateSigned.Name := 'DeclarationDateSigned';
    DeclarationDateSigned.Left := 19;
    DeclarationDateSigned.Top := 384;
    DeclarationDateSigned.Width := 170;
    DeclarationDateSigned.Height := 22;
    DeclarationDateSigned.ElementClassName := 'form-control';
    DeclarationDateSigned.HeightStyle := ssAuto;
    DeclarationDateSigned.WidthStyle := ssAuto;
    DeclarationDateSigned.BorderStyle := bsSingle;
    DeclarationDateSigned.ChildOrder := 6;
    DeclarationDateSigned.Color := clWhite;
    DeclarationDateSigned.Date := 45940.498711666670000000;
    DeclarationDateSigned.ElementPosition := epIgnore;
    DeclarationDateSigned.Role := '';
    DeclarationDateSigned.Text := '';
    SetEvent(DeclarationDateSigned, Self, 'OnChange', 'CompChange');
    DeclarationDateSigned.DataField := 'DateSigned';
    DeclarationDateSigned.DataSource := DeclarationDataSource;
    RevocationNote.SetParentComponent(Self);
    RevocationNote.Name := 'RevocationNote';
    RevocationNote.Left := 19;
    RevocationNote.Top := 648;
    RevocationNote.Width := 170;
    RevocationNote.Height := 22;
    RevocationNote.ChildOrder := 13;
    RevocationNote.ElementClassName := 'form-control';
    RevocationNote.ElementPosition := epIgnore;
    RevocationNote.HeightStyle := ssAuto;
    RevocationNote.HeightPercent := 100.000000000000000000;
    RevocationNote.Text := 'RevocationNote';
    RevocationNote.WidthStyle := ssAuto;
    RevocationNote.WidthPercent := 100.000000000000000000;
    SetEvent(RevocationNote, Self, 'OnChange', 'CompChange');
    RevocationNote.DataField := 'RevocationNote';
    RevocationNote.DataSource := DeclarationDataSource;
    DateRevoked.SetParentComponent(Self);
    DateRevoked.Name := 'DateRevoked';
    DateRevoked.Left := 19;
    DateRevoked.Top := 608;
    DateRevoked.Width := 170;
    DateRevoked.Height := 22;
    DateRevoked.ElementClassName := 'form-control';
    DateRevoked.HeightStyle := ssAuto;
    DateRevoked.WidthStyle := ssAuto;
    DateRevoked.BorderStyle := bsSingle;
    DateRevoked.ChildOrder := 13;
    DateRevoked.Color := clWhite;
    DateRevoked.Date := 45940.504224085650000000;
    DateRevoked.ElementPosition := epIgnore;
    DateRevoked.Role := '';
    DateRevoked.Text := '';
    SetEvent(DateRevoked, Self, 'OnChange', 'CompChange');
    DateRevoked.DataField := 'DateRevoked';
    DateRevoked.DataSource := DeclarationDataSource;
    NewDeclarationButton.SetParentComponent(Self);
    NewDeclarationButton.Name := 'NewDeclarationButton';
    NewDeclarationButton.Left := 184;
    NewDeclarationButton.Top := 336;
    NewDeclarationButton.Width := 96;
    NewDeclarationButton.Height := 25;
    NewDeclarationButton.Caption := 'New';
    NewDeclarationButton.ChildOrder := 14;
    NewDeclarationButton.ElementClassName := 'btn';
    NewDeclarationButton.ElementPosition := epIgnore;
    NewDeclarationButton.HeightStyle := ssAuto;
    NewDeclarationButton.HeightPercent := 100.000000000000000000;
    NewDeclarationButton.WidthStyle := ssAuto;
    NewDeclarationButton.WidthPercent := 100.000000000000000000;
    SetEvent(NewDeclarationButton, Self, 'OnClick', 'NewDeclarationButtonClick');
    DeclarationStatus.SetParentComponent(Self);
    DeclarationStatus.Name := 'DeclarationStatus';
    DeclarationStatus.Left := 19;
    DeclarationStatus.Top := 440;
    DeclarationStatus.Width := 170;
    DeclarationStatus.Height := 22;
    DeclarationStatus.ElementClassName := 'form-select';
    DeclarationStatus.ElementPosition := epIgnore;
    DeclarationStatus.HeightStyle := ssAuto;
    DeclarationStatus.HeightPercent := 100.000000000000000000;
    DeclarationStatus.WidthStyle := ssAuto;
    DeclarationStatus.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationStatus, Self, 'OnChange', 'CompChange');
    DeclarationStatus.DataField := 'DeclarationStatus';
    DeclarationStatus.DataSource := DeclarationDataSource;
    ClaimCoverage.SetParentComponent(Self);
    ClaimCoverage.Name := 'ClaimCoverage';
    ClaimCoverage.Left := 19;
    ClaimCoverage.Top := 487;
    ClaimCoverage.Width := 170;
    ClaimCoverage.Height := 22;
    ClaimCoverage.ElementClassName := 'form-select';
    ClaimCoverage.ElementPosition := epIgnore;
    ClaimCoverage.HeightStyle := ssAuto;
    ClaimCoverage.HeightPercent := 100.000000000000000000;
    ClaimCoverage.WidthStyle := ssAuto;
    ClaimCoverage.WidthPercent := 100.000000000000000000;
    SetEvent(ClaimCoverage, Self, 'OnChange', 'ClaimCoverageChange');
    ClaimCoverage.DataField := 'ClaimCoverage';
    ClaimCoverage.DataSource := DeclarationDataSource;
    DeclarationMethod.SetParentComponent(Self);
    DeclarationMethod.Name := 'DeclarationMethod';
    DeclarationMethod.Left := 19;
    DeclarationMethod.Top := 526;
    DeclarationMethod.Width := 170;
    DeclarationMethod.Height := 22;
    DeclarationMethod.ElementClassName := 'form-select';
    DeclarationMethod.ElementPosition := epIgnore;
    DeclarationMethod.HeightStyle := ssAuto;
    DeclarationMethod.HeightPercent := 100.000000000000000000;
    DeclarationMethod.WidthStyle := ssAuto;
    DeclarationMethod.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationMethod, Self, 'OnChange', 'CompChange');
    DeclarationMethod.DataField := 'DeclarationMethod';
    DeclarationMethod.DataSource := DeclarationDataSource;
    RevocationMethod.SetParentComponent(Self);
    RevocationMethod.Name := 'RevocationMethod';
    RevocationMethod.Left := 19;
    RevocationMethod.Top := 565;
    RevocationMethod.Width := 170;
    RevocationMethod.Height := 22;
    RevocationMethod.ElementClassName := 'form-select';
    RevocationMethod.ElementPosition := epIgnore;
    RevocationMethod.HeightStyle := ssAuto;
    RevocationMethod.HeightPercent := 100.000000000000000000;
    RevocationMethod.WidthStyle := ssAuto;
    RevocationMethod.WidthPercent := 100.000000000000000000;
    SetEvent(RevocationMethod, Self, 'OnChange', 'CompChange');
    RevocationMethod.DataField := 'RevocationMethod';
    RevocationMethod.DataSource := DeclarationDataSource;
    RevokeCheckDlg.SetParentComponent(Self);
    RevokeCheckDlg.Name := 'RevokeCheckDlg';
    RevokeCheckDlg.Left := 664;
    RevokeCheckDlg.Top := 368;
    RevokeCheckDlg.Width := 24;
    RevokeCheckDlg.Height := 24;
    RevokeCheckDlg.Buttons := [];
    RevokeCheckDlg.Opacity := 0.200000000000000000;
    SingleDonations.SetParentComponent(Self);
    SingleDonations.Name := 'SingleDonations';
    SingleDonations.Left := 208;
    SingleDonations.Top := 565;
    SingleDonations.Width := 170;
    SingleDonations.Height := 22;
    SingleDonations.ElementClassName := 'form-select';
    SingleDonations.ElementPosition := epIgnore;
    SingleDonations.HeightStyle := ssAuto;
    SingleDonations.HeightPercent := 100.000000000000000000;
    SingleDonations.WidthStyle := ssAuto;
    SingleDonations.WidthPercent := 100.000000000000000000;
    SingleDonations.ItemIndex := -1;
    DeclarationDataSource.SetParentComponent(Self);
    DeclarationDataSource.Name := 'DeclarationDataSource';
    DeclarationDataSource.DataSet := DeclarationDataSet;
    DeclarationDataSource.Left := 664;
    DeclarationDataSource.Top := 32;
    DeclarationDataSet.SetParentComponent(Self);
    DeclarationDataSet.Name := 'DeclarationDataSet';
    DeclarationDataSet.AfterApplyUpdates := DeclarationDataSetAfterApplyUpdates;
    DeclarationDataSet.AfterPost := DeclarationDataSetAfterPost;
    DeclarationDataSet.EntitySetName := 'GiftAidDeclaration';
    DeclarationDataSet.Connection := MainData.DataConnection;
    DeclarationDataSet.Left := 600;
    DeclarationDataSet.Top := 40;
    DeclarationDataSetId.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetId.Name := 'DeclarationDataSetId';
    DeclarationDataSetId.FieldName := 'Id';
    DeclarationDataSetDateAdded.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDateAdded.Name := 'DeclarationDataSetDateAdded';
    DeclarationDataSetDateAdded.FieldName := 'DateAdded';
    DeclarationDataSetAddedBy.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetAddedBy.Name := 'DeclarationDataSetAddedBy';
    DeclarationDataSetAddedBy.FieldName := 'AddedBy';
    DeclarationDataSetLastUpdatedBy.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetLastUpdatedBy.Name := 'DeclarationDataSetLastUpdatedBy';
    DeclarationDataSetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DeclarationDataSetLastUpdated.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetLastUpdated.Name := 'DeclarationDataSetLastUpdated';
    DeclarationDataSetLastUpdated.FieldName := 'LastUpdated';
    DeclarationDataSetDonorId.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDonorId.Name := 'DeclarationDataSetDonorId';
    DeclarationDataSetDonorId.FieldName := 'DonorId';
    DeclarationDataSetDateSigned.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDateSigned.Name := 'DeclarationDataSetDateSigned';
    DeclarationDataSetDateSigned.FieldName := 'DateSigned';
    DeclarationDataSetDateStarted.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDateStarted.Name := 'DeclarationDataSetDateStarted';
    DeclarationDataSetDateStarted.FieldName := 'DateStarted';
    DeclarationDataSetClaimCoverage.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetClaimCoverage.Name := 'DeclarationDataSetClaimCoverage';
    DeclarationDataSetClaimCoverage.FieldName := 'ClaimCoverage';
    DeclarationDataSetClaimCoverage.Size := 6;
    DeclarationDataSetDeclarationMethod.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDeclarationMethod.Name := 'DeclarationDataSetDeclarationMethod';
    DeclarationDataSetDeclarationMethod.FieldName := 'DeclarationMethod';
    DeclarationDataSetDeclarationMethod.Size := 14;
    DeclarationDataSetDateRevoked.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDateRevoked.Name := 'DeclarationDataSetDateRevoked';
    DeclarationDataSetDateRevoked.FieldName := 'DateRevoked';
    DeclarationDataSetRevocationMethod.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetRevocationMethod.Name := 'DeclarationDataSetRevocationMethod';
    DeclarationDataSetRevocationMethod.FieldName := 'RevocationMethod';
    DeclarationDataSetRevocationMethod.Size := 14;
    DeclarationDataSetDeclarationStatus.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDeclarationStatus.Name := 'DeclarationDataSetDeclarationStatus';
    DeclarationDataSetDeclarationStatus.FieldName := 'DeclarationStatus';
    DeclarationDataSetDeclarationStatus.Size := 11;
    DeclarationDataSetRevocationNote.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetRevocationNote.Name := 'DeclarationDataSetRevocationNote';
    DeclarationDataSetRevocationNote.FieldName := 'RevocationNote';
    DeclarationDataSetRevocationNote.Size := 255;
    DeclarationDataSetDonationId.SetParentComponent(DeclarationDataSet);
    DeclarationDataSetDonationId.Name := 'DeclarationDataSetDonationId';
    DeclarationDataSetDonationId.FieldName := 'DonationId';
    Refresh.SetParentComponent(Self);
    Refresh.Name := 'Refresh';
    Refresh.Enabled := False;
    Refresh.Interval := 200;
    SetEvent(Refresh, Self, 'OnTimer', 'RefreshTimer');
    Refresh.Left := 760;
    Refresh.Top := 56;
    RefreshDeclarations.SetParentComponent(Self);
    RefreshDeclarations.Name := 'RefreshDeclarations';
    RefreshDeclarations.Enabled := False;
    SetEvent(RefreshDeclarations, Self, 'OnTimer', 'RefreshDeclarationsTimer');
    RefreshDeclarations.Left := 752;
    RefreshDeclarations.Top := 224;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    DeclarationCloseButton.AfterLoadDFMValues;
    DeclarationCancelButton.AfterLoadDFMValues;
    SaveDeclarationButton.AfterLoadDFMValues;
    DeclarationDataTable.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DeclarationDateSigned.AfterLoadDFMValues;
    RevocationNote.AfterLoadDFMValues;
    DateRevoked.AfterLoadDFMValues;
    NewDeclarationButton.AfterLoadDFMValues;
    DeclarationStatus.AfterLoadDFMValues;
    ClaimCoverage.AfterLoadDFMValues;
    DeclarationMethod.AfterLoadDFMValues;
    RevocationMethod.AfterLoadDFMValues;
    RevokeCheckDlg.AfterLoadDFMValues;
    SingleDonations.AfterLoadDFMValues;
    DeclarationDataSource.AfterLoadDFMValues;
    DeclarationDataSet.AfterLoadDFMValues;
    DeclarationDataSetId.AfterLoadDFMValues;
    DeclarationDataSetDateAdded.AfterLoadDFMValues;
    DeclarationDataSetAddedBy.AfterLoadDFMValues;
    DeclarationDataSetLastUpdatedBy.AfterLoadDFMValues;
    DeclarationDataSetLastUpdated.AfterLoadDFMValues;
    DeclarationDataSetDonorId.AfterLoadDFMValues;
    DeclarationDataSetDateSigned.AfterLoadDFMValues;
    DeclarationDataSetDateStarted.AfterLoadDFMValues;
    DeclarationDataSetClaimCoverage.AfterLoadDFMValues;
    DeclarationDataSetDeclarationMethod.AfterLoadDFMValues;
    DeclarationDataSetDateRevoked.AfterLoadDFMValues;
    DeclarationDataSetRevocationMethod.AfterLoadDFMValues;
    DeclarationDataSetDeclarationStatus.AfterLoadDFMValues;
    DeclarationDataSetRevocationNote.AfterLoadDFMValues;
    DeclarationDataSetDonationId.AfterLoadDFMValues;
    Refresh.AfterLoadDFMValues;
    RefreshDeclarations.AfterLoadDFMValues;
  end;
end;

end.